import { render } from "./AppHeaderDropdownMssgs.vue?vue&type=template&id=3c4bb129"
import script from "./AppHeaderDropdownMssgs.vue?vue&type=script&lang=js"
export * from "./AppHeaderDropdownMssgs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aks/Desktop/WORK/Codes/HCL Harit/HCL_coreui_vue_Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__